"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

var _util = require("../../../util");

var css = _interopRequireWildcard(require("./Avatar.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * Avatars rounded photographic representations of a user, for personalising
 * their experience.
 *
 * Avatar accepts an `image` prop, which should be a URL for the image to be
 * displayed. It also accepts a `name` prop, which will be used to accessibly
 * label the avatar. If no `image` value is provided, the initials from the name
 * string will be shown on a colored background instead.
 *
 * The Avatar component also provides a `size` prop, for setting the height &
 * width of the avatar.
 *
 * All other unhandled props are spread to the root element.
 */
const Avatar = /*#__PURE__*/React.forwardRef(({
  as: asProp = 'button',
  image,
  name = '',
  size = 'large',
  type,
  ...otherProps
}, ref) => {
  const showImage = image;
  const showInitials = name && !image;
  const showFallback = !name && !image;
  return (0, _pragma.createFelaElement)(_.View, _extends({
    alignItems: "center",
    "aria-label": name || 'User Avatar',
    as: asProp,
    css: css.avatar,
    cssProps: {
      size
    },
    justifyContent: "center",
    ref: ref,
    type: asProp === 'button' && !type ? 'button' : undefined
  }, otherProps), showImage && (0, _pragma.createFelaElement)("img", {
    alt: "",
    css: css.image,
    loading: "lazy",
    src: image
  }), (0, _pragma.createFelaElement)("div", {
    css: css.overlay,
    "data-overlay": true
  }), showInitials && (0, _pragma.createFelaElement)(_.Text, {
    "aria-hidden": true,
    children: (0, _util.getInitials)(name),
    color: "text.3",
    css: css.content,
    lineHeight: "xs",
    size: size === 'small' ? 's' : undefined,
    transform: "uppercase",
    weight: "bold"
  }), showFallback && (0, _pragma.createFelaElement)(_.SupportIcon, {
    css: css.content,
    color: "text.3"
  }));
});
Avatar.displayName = 'Avatar';
var _default = Avatar;
exports.default = _default;
//# sourceMappingURL=Avatar.js.map